import createLumirIcon from "../create-lumir-icon";

const ChevronDown = createLumirIcon("ChevronDown", [
  [
    "path",
    {
      key: "chevron-down",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor",
      d: "M10 14.4305C9.73947 14.4305 9.48004 14.3425 9.2686 14.1654L2.41133 8.45068C1.92675 8.04722 1.86046 7.32603 2.26504 6.84142C2.66848 6.35682 3.38849 6.29167 3.87422 6.69513L10.0126 11.8109L16.1407 6.87914C16.6322 6.48368 17.3522 6.5614 17.7476 7.05287C18.1431 7.54433 18.0653 8.26324 17.5739 8.65984L10.7166 14.178C10.5075 14.346 10.2538 14.4305 10 14.4305Z",
    },
  ],
]);

export default ChevronDown;
